import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromDRWTS from './direct-reports-with-time-status.actions';
import { switchMap, map, tap, catchError } from 'rxjs/operators';
import { TimeCardService } from '../time-card.service';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromShared from '../../shared';
@Injectable()
export class DirectReportsWithTimeStatusEffects {
    constructor(
        private actions$: Actions,
        @Inject(TimeCardService) private service: TimeCardService,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    getDirectReportsWithTimeStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromDRWTS.getDirectReportsWithTimeStatus),
            tap((a) =>
                this.log.verbose({
                    type:
                        'DirectReportsWithTimeStatusEffects:getDirectReportsWithTimeStatus$',
                    a,
                })
            ),
            switchMap((a) =>
                this.service
                    .getDirectReportsWithTimeStatus(
                        a.UserListID,
                        a.UserRole,
                        a.EmployeeListID,
                        a.StartDate,
                        a.EndDate,
                        a.MyDRsOnly
                    )
                    .pipe(
                        map((dr) =>
                            fromDRWTS.loadDirectReportsWithTimeStatuss({
                                directReportsWithTimeStatuss: dr,
                            })
                        ),
                        catchError(fromShared.Errors.handleServiceError)
                    )
            )
        )
    );
}
